var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42864 10.286C7.82313 10.286 8.14293 9.9662 8.14293 9.57171C8.14293 9.17722 7.82313 8.85742 7.42864 8.85742C7.03415 8.85742 6.71436 9.17722 6.71436 9.57171C6.71436 9.9662 7.03415 10.286 7.42864 10.286Z",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 9.57227H25.2856",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42864 16.7137C7.82313 16.7137 8.14293 16.3939 8.14293 15.9994C8.14293 15.605 7.82313 15.2852 7.42864 15.2852C7.03415 15.2852 6.71436 15.605 6.71436 15.9994C6.71436 16.3939 7.03415 16.7137 7.42864 16.7137Z",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 16H25.2856",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42864 23.1434C7.82313 23.1434 8.14293 22.8236 8.14293 22.4291C8.14293 22.0346 7.82313 21.7148 7.42864 21.7148C7.03415 21.7148 6.71436 22.0346 6.71436 22.4291C6.71436 22.8236 7.03415 23.1434 7.42864 23.1434Z",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 22.4277H25.2856",
    stroke: "#22222A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.0fd912fc691179103ce848263079bf78.svg";
export { ForwardRef as ReactComponent };